// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px) {
  .qr-scan-card {
    display: none !important;
  }
  .events-container {
    display: flex;
    flex-direction: column;
    padding-bottom: 100px;
    width: 100%;
    /* space for bottom button */
  }
  .events-container > .heading-24 {
    order: 1;
    font-size: 1.1rem;
    margin-top: 1rem;
  }
  .events-container > .heading-24 .btn-create-event {
    display: none;
  }
  .events-container > .horizontal-tab,
  .horizontal-tab {
    order: 2;
    overflow-x: auto;
    white-space: nowrap;
    margin-bottom: 1rem;
    width: 100%;
  }
  .events-container > .tab-content {
    order: 3;
  }
  /* Fix create button at the bottom */
}`, "",{"version":3,"sources":["webpack://./src/routes/event-list/events/style.scss"],"names":[],"mappings":"AAAA;EAEE;IACE,wBAAA;EAAF;EAGA;IACE,aAAA;IACA,sBAAA;IACA,qBAAA;IACA,WAAA;IACC,4BAAA;EADH;EAIA;IACE,QAAA;IACA,iBAAA;IACA,gBAAA;EAFF;EAIE;IACE,aAAA;EAFJ;EAMA;;IAEE,QAAA;IACA,gBAAA;IACA,mBAAA;IACA,mBAAA;IACA,WAAA;EAJF;EAOA;IACE,QAAA;EALF;EAQA,oCAAA;AANF","sourcesContent":["@media (max-width: 768px) {\n\n  .qr-scan-card {\n    display: none !important;\n  }\n\n  .events-container {\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 100px;\n    width: 100%;\n     /* space for bottom button */\n  }\n\n  .events-container > .heading-24 {\n    order: 1;\n    font-size: 1.1rem;\n    margin-top: 1rem;\n\n    .btn-create-event {\n      display: none;\n    }\n  }\n\n  .events-container > .horizontal-tab,\n  .horizontal-tab {\n    order: 2;\n    overflow-x: auto;\n    white-space: nowrap;\n    margin-bottom: 1rem;\n    width: 100%;\n  }\n\n  .events-container > .tab-content {\n    order: 3;\n  }\n\n  /* Fix create button at the bottom */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
